import React from 'react';
import Form from 'react-bootstrap/Form';
import {Helmet} from 'react-helmet'

function Contact(props) {
  const mail = "que.org.members@gmail.com"

  const translation = {
   'ja' :{
     contact: "お問い合わせ",
     description: <React.Fragment>下記フォームをご記入いただいた上，「送信」ボタンを押してください。<br/>
     お問い合わせの内容によっては、お時間を頂戴する場合がございます。</React.Fragment>,
     contactTypes: [
        "イベントの内容について",
        "イベント参加方法について",
        "その他"
     ],
     titles: {
      type: "お問い合わせの種類",
      name: "お名前",
      mail: "メールアドレス",
      affiliation: "ご所属",
      subject: "件名",
      content: "お問い合わせ内容"
     },
     placeholder: {
       name: "佐藤 太郎"
     },
     required: {
       true: "必須",
       false: "任意"
     },
     send: "送信"
    },
    "en":{
      contact: "Contact",
      description: <React.Fragment>Please fill out the form below and click [submit] button to send.<br/>
      We will get back to you as soon as possible.</React.Fragment>,
      contactTypes: [
        "About event content",
        "About registration",
        "Other"
      ],
      titles: {
        type: "Content of inquiry",
        name: "Your name",
        mail: "Email",
        affiliation: "Affiliation",
        subject: "Inquiry subject",
        content: "Message"
      },
      placeholder: {
        name: "Joe Bloggs"
      },
      required: {
        true: "required",
        false: "optional"
      },
      send: "Submit"
    },
  }

  const {contact, description, contactTypes, titles, placeholder, required, send} = translation[props.language]

  const isRequired = (input) => {
    return (
      <div className={input ? "required" : "optional"}>
        {input ? required.true : required.false}
      </div>
    )
  }
  

  return (
    <div className="contact-form">
      <Helmet>
        <title>QUE {contact}</title>
      </Helmet>
      <h3 className="title">{contact}</h3>
      <p >{description}</p>
      <form method="POST" action={"https://formspree.io/" + mail} >
        <h5 className="sec-title">{titles.type} <br/>{isRequired(true)}</h5>
        <Form.Control name='お問い合わせの種類' as="select">
          {
            contactTypes.map((t) => (<option key={t} value={t}>{t}</option>))
          }
        </Form.Control>
        <h5 className="sec-title">{titles.name} <br/>{isRequired(true)}</h5>
        <input type='text' name='お名前' placeholder={placeholder.name} />
        <h5 className="sec-title">{titles.mail} <br/>{isRequired(true)}</h5>
        <input type="email" name="返信先" placeholder="you@example.com"/>
        <h5 className="sec-title">{titles.affiliation}<br/>{isRequired(false)}</h5>
        <input type='text' name='所属'  />
        <h5 className="sec-title">{titles.subject}<br/>{isRequired(true)}</h5>
        <input type='text' name='件名' />
        <h5 className="sec-title">{titles.content} <br/>{isRequired(true)}</h5>
        <textarea name='お問い合わせ内容'></textarea>
        <input className='submit' type="submit" value={send}/>
      </form>
    </div>
  );
}

export default Contact;